import { ClientEventRow } from '@entities/clients';
import { FilterItem } from '../SearchCheckboxFilterDropdown';
import { CALLS_FILTER_ALL } from '../consts';

export interface ClientSideFilters {
  selectedBrokersFilter: string[];
  selectedCallsFilter: string;
  isInvitingManagersFilter: boolean;
  selectedAllManagersFilter: string[];
  selectedInvitingManagersFilter: string[];
}

export type CallsSortDirection = 'asc' | 'desc' | null;

export interface ClientTableFilterItems {
  brokerFilterItems: FilterItem<string>[];
  allManagerFilterItems: FilterItem<string>[];
  invitingManagerFilterItems: FilterItem<string>[];
}

export interface ClientTableView {
  rows: ClientEventRow[];
  hasBrokerFilter: boolean;
  hasManagerFilter: boolean;
  hasCallsFilter: boolean;
}

export const INITIAL_CLIENT_FILTERS: ClientSideFilters = {
  selectedBrokersFilter: [],
  selectedCallsFilter: CALLS_FILTER_ALL,
  isInvitingManagersFilter: false,
  selectedAllManagersFilter: [],
  selectedInvitingManagersFilter: [],
};

export interface ManagerFilterPayload {
  isInvitingOnly: boolean;
  allManagers: string[];
  invitingNames: string[];
}

export interface ActiveSort {
  column: string;
  direction: 'asc' | 'desc';
}
